import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

// jquery-modal options for every modal, including the rel="modal:open" links the plugin opens by
// itself. Every file that opens a modal imports this module, so the defaults are in place first.
// Applied again after a Turbo visit, whose re-run CDN jQuery comes back with the plugin's own
// defaults.
onPageLoad(() => {
  // The onboarding layout boots Stimulus without jQuery.
  if (!window.jQuery?.modal) {
    return;
  }

  $.modal.defaults = {
    clickClose: false,
    modalClass: 'modal',
    escapeClose: true,
    closeExisting: true,
    showClose: true,
  };
});
